import { FC, css } from "dreamland/core";
import humanizeDuration from "humanize-duration";
import TransitionLink from "./TransitionLink";

type DocumentWithViewTransition = Document & {
	startViewTransition?: (
		callback: () => void | Promise<void>
	) => ViewTransition;
};

const messages: string[] = [
	"[Praying to RNGesus...]",
	"Nine parts perspiration.",
	"Take care of yourself.",
	"It's over 9000!",
	"Something wonderful has happened",
	"Hack the Planet!",
	"Copy that floppy!",
	"And the universe said I love you, because you are love.",
	"Always try to be nice, but never fail to be kind.",
];

type FooterState = {
	elapsed: string;
	message: string;
};

function Footer(this: FC<{}, FooterState>) {
	this.elapsed = `built on ${new Date(__BUILD_DATE__).toLocaleDateString()}`;
	this.message = "<insert funny message here>";

	const runSplashTransition = (update: () => void) => {
		if (typeof document === "undefined") {
			update();
			return;
		}
		const doc = document as DocumentWithViewTransition;
		if (typeof doc.startViewTransition !== "function") {
			update();
			return;
		}
		const root = document.documentElement;
		root.dataset.vtScope = "splash";
		try {
			const transition = doc.startViewTransition(() => {
				update();
			});
			transition.finished.finally(() => {
				if (root.dataset.vtScope === "splash") {
					delete root.dataset.vtScope;
				}
			});
		} catch (error) {
			delete root.dataset.vtScope;
			update();
			return;
		}
	};

	const pickNewSplashMessage = () => {
		const old = this.message;
		let message = old;
		while (message === old) {
			message = messages[Math.floor(Math.random() * messages.length)];
		}
		this.message = message;
	};

	const shuffleSplash = () => {
		runSplashTransition(pickNewSplashMessage);
	};
	const buildDate = new Date(__BUILD_DATE__);
	const updateElapsed = () => {
		const diff = Date.now() - buildDate.getTime();
		this.elapsed = "built " + humanizeDuration(diff, { round: true }) + " ago";
	};

	this.cx.mount = () => {
		if (import.meta.env.SSR) {
			return;
		}

		this.message = messages[Math.floor(Math.random() * messages.length)];
		updateElapsed();
	};

	return (
		<footer>
			<subt>
				<span class="tooltip-wrapper" on:pointerenter={updateElapsed}>
					<TransitionLink href="/siteinfo.html" class="router-link">
						{"bomberfish.ca v" + __APP_VERSION__ + " (" + __COMMIT_HASH__ + ")"}
					</TransitionLink>
					<span class="tooltip top">{use(this.elapsed)}</span>
				</span>
				<span on:click={shuffleSplash} class="splash">
					{use(this.message)}
					<noscript> Enable JavaScript, you damn luddite!</noscript>
				</span>
			</subt>
		</footer>
	);
}

Footer.style = css`
	:scope {
		margin-top: auto;
		font-size: 0.75rem;
		user-select: none;
		width: calc(100% - 1.25rem);
	}

	subt {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
	}

	.splash {
		color: var(--subtext2);
		cursor: pointer;
		view-transition-name: splash-message;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export default Footer;
